import Environment from '../utils/Environment.js';

class StripeConfiguration {
    static get apiKey() {
        return Environment.isDevelopment ? "pk_test_TeIOoDhZmL0AGpc8urO71U4C" : "pk_live_QQK4XJw0drvGGPt62u4A8OSr";
    }
}

export default StripeConfiguration;